<template>
	<div class="bg-gradient-to-tr from-indigo-900 mb-4 shadow shadow-2xl rounded-lg to-fuchsia-900 via-black shadow mb-4">
		<div class="px-4 py-5 sm:p-6">
			<div class="block sm:flex items-baseline">
				<h3 class="font-gilroyLight font-semibold leading-6 text-2xl text-white">Unlock unlimited access</h3>
				<div class="ml-0 sm:ml-2 text-sm text-gray-400">
					<p>Enter your <a class="underline decoration-sky-500 font-bold">work email</a> to join your company account. <a class="underline decoration-pink-500 font-bold ml-0 sm:ml-2">Personal use</a> discounted.</p>
				</div>
			</div>

			<div>
				<div v-if="!form.wasSuccessful" class="block sm:flex rounded-md shadow-sm mt-4">
					<div class="flex items-center">
						<div class="relative flex flex-grow max-w-xs sm:w-80 items-stretch focus-within:z-10">
							<div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 text-gray-400">
									<path d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z" />
									<path d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z" />
								</svg>
							</div>
							<input v-model="form.email" :onfocus="clearFormErrors" type="email" name="email" id="email" class="block w-full rounded-none rounded-l-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="you@company.com" />
						</div>
						<button :disabled="form.processing" @click="submitEmail" type="button" class="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 bg-gray-100 hover:bg-gray-200">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="-ml-0.5 h-5 w-5 text-gray-400">
								<path fill-rule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clip-rule="evenodd" />
							</svg>
							Submit
						</button>
					</div>
					<div class="block sm:flex items-center mt-4 sm:mt-0">

						<div v-if="!form.errors.email" class="flex mt-1 ml-0 sm:ml-4 items-center">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
								 fill="currentColor" class="h-4 w-4 text-green-500">
								<path fill-rule="evenodd"
									  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
									  clip-rule="evenodd"></path>
							</svg>
							<p class="font-bold font-gilroyRegular ml-2 text-gray-400 text-sm tracking-wide">2000+ one-click icons for Google Slides</p>
						</div>
						<div v-if="!form.errors.email" class="flex mt-1 ml-0 sm:ml-6 items-center">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
								 fill="currentColor" class="h-4 w-4 text-green-500">
								<path fill-rule="evenodd"
									  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
									  clip-rule="evenodd"></path>
							</svg>
							<p class="font-bold font-gilroyRegular ml-2 text-gray-400 text-sm tracking-wide">Fully editable shapes, not images</p>
						</div>

						<div v-if="form.errors.email">
							<div class="flex mt-1 ml-4 items-center">

								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4 text-red-500">
									<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
								</svg>

								<p class="font-bold font-gilroyRegular ml-2 text-gray-400 text-sm tracking-wide">{{ form.errors.email }}</p>
							</div>

						</div>
					</div>
				</div>
				<div v-if="form.wasSuccessful">
					<div class="flex mt-4 ml-4 items-center">

						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
							 fill="currentColor" class="h-4 w-4 text-green-500">
							<path fill-rule="evenodd"
								  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
								  clip-rule="evenodd"></path>
						</svg>
						<p class="font-bold font-gilroyRegular ml-2 text-gray-400 text-sm tracking-wide">Check your email to verify your access!</p>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script setup>
import {useForm} from "@inertiajs/vue3";

const form = useForm({
	email: null,
})

function submitEmail() {

	form
		.post('/emailSubmit', {
			onSuccess: () => {
				// emit('close');
			}
		});


}

function clearFormErrors() {
	form.clearErrors();
}

</script>

